import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Form, Message, Modal } from 'semantic-ui-react'
import { Formik } from 'formik'
import React from 'react'

import { MutationErrorMessage } from '../../components'

const ModalEditUserAssignmentRequiresPaymentCard = ({
  onClose,
  service,
  onSubmit,
  mutation
}) => {
  const intl = useIntl()

  const userAssignmentRequiresPaymentCardOptions = {
    YES: 'YES',
    NO: 'NO'
  }

  const initialFormikData = (service) => {
    const { userAssignmentRequiresPaymentCard } = service
    return {
      userAssignmentRequiresPaymentCard: userAssignmentRequiresPaymentCard
        ? userAssignmentRequiresPaymentCardOptions.YES
        : userAssignmentRequiresPaymentCardOptions.NO
    }
  }

  const hasValueChanged = (userAssignmentRequiresPaymentCard) => {
    const newValue =
      userAssignmentRequiresPaymentCard ===
      userAssignmentRequiresPaymentCardOptions.YES
    return service.userAssignmentRequiresPaymentCard !== newValue
  }

  const handleFormikSubmit = ({ userAssignmentRequiresPaymentCard }) => {
    if (hasValueChanged(userAssignmentRequiresPaymentCard)) {
      onSubmit({
        serviceRef: service.ref,
        userAssignmentRequiresPaymentCard:
          userAssignmentRequiresPaymentCard ===
          userAssignmentRequiresPaymentCardOptions.YES
      })
    } else {
      onClose()
      return
    }
  }

  const hasConflictError = mutation.error?.statusCode === 409

  return (
    <Formik
      initialValues={initialFormikData(service)}
      onSubmit={handleFormikSubmit}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <Modal open onClose={onClose} size={'small'}>
          <Modal.Header
            content={intl.formatMessage(
              {
                id: 'modalEditUserAssignmentRequiresPaymentCard.title'
              },
              {
                name: service.name
              }
            )}
          />
          <Modal.Content>
            <Message info>
              <FormattedMessage id="modalEditUserAssignmentRequiresPaymentCard.info" />
            </Message>
            <MutationErrorMessage
              mutation={mutation}
              defaultErrorTextLangId={
                hasConflictError
                  ? 'modalEditUserAssignmentRequiresPaymentCard.action.error.conflict'
                  : 'modalEditUserAssignmentRequiresPaymentCard.action.error.update'
              }
              messageNegative
            />
            <Form onSubmit={handleSubmit}>
              <Form.Field>
                <label>
                  {intl.formatMessage({
                    id: 'modalEditUserAssignmentRequiresPaymentCard.label.userAssignmentRequiresPaymentCard'
                  })}
                </label>
              </Form.Field>
              <Form.Radio
                label={intl.formatMessage({
                  id: 'common.yes'
                })}
                value={userAssignmentRequiresPaymentCardOptions.YES}
                checked={
                  values.userAssignmentRequiresPaymentCard ===
                  userAssignmentRequiresPaymentCardOptions.YES
                }
                onChange={(event, data) => {
                  setFieldValue('userAssignmentRequiresPaymentCard', data.value)
                }}
              />
              <Form.Radio
                label={intl.formatMessage({
                  id: 'common.no'
                })}
                value={userAssignmentRequiresPaymentCardOptions.NO}
                checked={
                  values.userAssignmentRequiresPaymentCard ===
                  userAssignmentRequiresPaymentCardOptions.NO
                }
                onChange={(event, data) => {
                  setFieldValue('userAssignmentRequiresPaymentCard', data.value)
                }}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={onClose}>
              <FormattedMessage id="common.button.cancel" />
            </Button>
            <Button
              type="submit"
              primary
              loading={mutation.isPending}
              disabled={mutation.isPending}
              onClick={handleSubmit}
            >
              <FormattedMessage id="common.button.save" />
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  )
}

export default ModalEditUserAssignmentRequiresPaymentCard
